import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual, find } from 'lodash';
import {Helmet} from 'react-helmet';
import moment from 'moment';
import CSV from '../../helpers/CSVExport';
import { pdf as PDFRenderer }from '@react-pdf/renderer';

import Box from '../../components/common/Box';
import ReactSelect from '../../components/common/ReactSelect';
import { territoriesActions } from '../../data/actions/territories';
import RollingMonthRevenue from '../../components/pages/territories/RollingMonthRevenue';
import ProductType from '../../components/pages/territories/ProductType';
import Countries from '../../components/pages/territories/Countries';
import Sources from '../../components/pages/territories/Sources';
import SourcesRatio from '../../components/pages/territories/SourcesRatio';
import SharePage from '../../components/pages/sharedPages/SharePage';
import PDFDocument from '../../components/pages/territories/PDFOverview';

const downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');
const pdfSvg = require('!svg-inline-loader!../../../public/img/pdf.svg');

class TerritoriesOverview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			period: 'year'
		};
		this.exportToCsv = this.exportToCsv.bind(this);
		this.exportToPdf = this.exportToPdf.bind(this);
		// this.setPeriod = this.setPeriod.bind(this);
	}
	
	componentDidMount() {
		this.props.dispatch(territoriesActions.getTerritories({
			...this.props,
			continent: null, 
			territories: null
		}));
	}
	/*
	
	setPeriod({value: period}){
		this.setState({period}, ()=>{
			this.props.dispatch(territoriesActions.getTerritories(null, null, this.state.period));	
		})
	}
	
	*/

getExportTables(territories){
		const overview = territories.metrics.table.map(row=>{
			const {incomes, ...rest} = row;
			return rest;  
		}); 
		const countries = territories.metrics.table.map(row=>{
			const {incomes, period} = row;
			let result = {
				period
			};
			for(let country of incomes) {
				result[country.continent] = country.income;
			}
			return result;
		}); 
		
		return {overview, countries}
	}
	
	exportToCsv = () => {
	  const {
		territories
	  } = this.props;
	
	  const {overview, countries} = this.getExportTables(territories);
	
	  const data = [
		{ overview },
		{ countries },
		{ rolling_12_months_revenue: territories.months },  
	  ];
	  
	  const { dateStart: bulkDateStart, dateEnd: bulkDateEnd } = this.props;
  const filename = CSV.CSVHeader('territories_report', null, (bulkDateStart && bulkDateEnd) ? {dateStart: bulkDateStart, dateEnd: bulkDateEnd} : null);
	
	  CSV.CSVBulkExport(data, filename);
	
	}
	
	getPdfData() {
		const reportTitle = 'Territories Report',
		{ 
			territories
		} = this.props
			
		const imageIDs = [
		];
		let images = {};
		for (let imageID of imageIDs){
			let image = document.getElementById(imageID);
			if(image)
				images[imageID] = image.toDataURL("image/jpeg,1.0"); 
		}
		
		const {overview, countries} = this.getExportTables(territories);
	
		const tables = {
			overview,
			countries,
			rolling_12_months_revenue: territories.months,
		};
		return { reportTitle, images, tables };
	}
	
	exportToPdf() {
		const data = PDFRenderer(<PDFDocument data={this.getPdfData()} />);
		
		data.toBlob()
		.then(blob=>{
			const fileURL = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = fileURL;
			link.download = (this.props.dateStart && this.props.dateEnd) ? `territories_report-${moment(this.props.dateStart).format('YYYYMMDD')}-${moment(this.props.dateEnd).format('YYYYMMDD')}.pdf` : "Territories Report.pdf";
			link.click();
		});
	}
	
	

	render() {		
		const { sharedMode, dateStart, dateEnd, overrideGlobal } = this.props;
		const { metrics, loading, table } = this.props.territories;
		console.log('sharedMode');
		console.log(sharedMode);

		return <div className="project-details artist-profile homepage">
			<div className="container">
				<div className="row download-page download-page--mt">
					<span>Export the data </span>
					{sharedMode && <React.Fragment>
						<a key="download" title="Download entire page" onClick={this.exportToCsv} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
						<span>PDF</span>
						<a key="pdf" title="Download PDF" onClick={this.exportToPdf} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: pdfSvg}} />
						</React.Fragment>
					}
					{!sharedMode && <div className="form-group button-container">
						<SharePage entity="overview" module="territories" forceShow={true} CSVEntities={[]} flatCSVExport={true} overrideGlobal={overrideGlobal} exportToCsv={this.exportToCsv} exportToPdf={this.exportToPdf} />
					</div>}



				</div>    
				<div className="row">
					<div className="col-xs-6 pd-0 default">
						<Sources {...metrics} loading={loading} dateStart={dateStart} dateEnd={dateEnd} />
					</div>
					<div className="col-xs-6 pd-0 default">
						<Countries continent={null} {...metrics} loading={loading} dateStart={dateStart} dateEnd={dateEnd} />
					</div>
				</div>
				<div className="row">
					<div className="col-xs-6 pd-0 default">
						<SourcesRatio {...metrics} loading={loading} dateStart={dateStart} dateEnd={dateEnd} />
					</div>
					<div className="col-xs-6 pd-0 default">
						<ProductType {...metrics} loading={loading} dateStart={dateStart} dateEnd={dateEnd} />
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 pd-0 default">
						<RollingMonthRevenue filter={{
							...this.props,
							continent: null,
							territories: null
						}} />
					</div>
				</div>                        
				<Helmet>
					<title>Territories</title>
				</Helmet>
			</div>
		</div>
	}
}

function mapStateToProps(state) {
	return {
		territories: state.territories,
		filter: state.filter,
	}
}

export default connect(mapStateToProps)(TerritoriesOverview)
